/* global loader createCookie trim Uri */

$(document).ready(function () {
    const uri = new Uri(location.href);
    if (uri.getParam('giftCodeValue')) {
        loader.showPageLoader();
        const giftCodeValue = uri.getParam('giftCodeValue');
        createCookie('cartGiftCodeAmount', giftCodeValue, 0);
        const redeemDestination = (uri.getParam('redeemDestination')) ? decodeURI(uri.getParam('redeemDestination')).replace(/&amp;/g, '&') : '';
        if (redeemDestination && window.isDcUrl(redeemDestination)) {
            window.location = (!/^http/.test(redeemDestination) ? baseURL : '') + redeemDestination;
        } else {
            window.location = baseURL + 'donors/search.html';
        }
    }

    $('.js-redeem-gc-form').on('submit', function () {
        $('.error-text').remove();
        $('.hasError').removeClass('hasError');

        if (!document.getElementById('giftCode') || trim(document.getElementById('giftCode').value) === '') {
            $('#giftCode').addClass('hasError');
            $('#giftCode').after('<div class="error-text">Please include your gift code.</div>');
            return false;
        }
        if (document.getElementById('additionalField') && document.getElementById('additionalField').value === '') {
            $('#additionalField').addClass('hasError');
            $('#additionalField').after('<div class="error-text">Please include your email address.</div>');
            return false;
        }
    });
});
